import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { DangerHexagon } from "@mynaui/icons-react";

const FailureHistory = ({ failures }) => {
  return (
    <Card sx={{ borderRadius: 1, flex: 1, boxShadow: "none", border: "none" }}>
      <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 0.5 }}>
          <DangerHexagon size={24} color="#020618" strokeWidth={1.5} />
          <Typography
            sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "28px", color: "#111827" }}
          >
            Failure History
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {failures.map((failure, index) => (
            <Box
              key={failure.id}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.5,
                py: 1.5,
                mt: "14px",
                borderBottom: index < failures.length - 1 ? "1px solid #E2E8F0" : "none",
              }}
            >
              <DangerHexagon size={24} color="#DC2626" strokeWidth={1.5} style={{ flexShrink: 0 }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  sx={{ fontWeight: 500, fontSize: "14px", lineHeight: "20px", color: "#020618", mb: 0.5 }}
                >
                  {failure.failureType}
                </Typography>
                {failure.description && (
                  <Typography
                    sx={{ fontSize: "12px", lineHeight: "16px", color: "#4B5563", mb: 0.5, whiteSpace: "pre-wrap" }}
                  >
                    {failure.description}
                  </Typography>
                )}
                <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: "#62748E" }}>
                  Reported: {failure.reportedAt}
                  {failure.resolvedAt ? `  ·  Resolved: ${failure.resolvedAt}` : ""}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default FailureHistory;
